import { render, staticRenderFns } from "./index.vue?vue&type=template&id=283130f0&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderMagazine: require('/home/smiley/3df/components/Header/HeaderMagazine/HeaderMagazine.vue').default,CardArticle: require('/home/smiley/3df/components/Card/CardArticle/CardArticle.vue').default,CardPromotion: require('/home/smiley/3df/components/Card/CardPromotion/CardPromotion.vue').default,Banner: require('/home/smiley/3df/components/Banner/Banner.vue').default,SectionRegister: require('/home/smiley/3df/components/Section/SectionRegister/SectionRegister.vue').default})
